/**
 * Site-specific JavaScript for frontend pages
 * Uses Tailwind CSS classes for dynamic styling
 */

/* global IntersectionObserver */

// Import any additional dependencies
import './bootstrap';
import { initializeFrontendShell } from './frontend-shell';
import { initializeHeader } from './header';

// Import React Panel Loader for dynamic React component mounting
// Temporarily disabled - only needed when React panels are used
// import './Components/ReactPanelLoader';

// Site-specific initialization
document.addEventListener('DOMContentLoaded', function() {
    // Site JavaScript loaded with Tailwind support

    // Initialize any site-specific functionality here
    initializeAnimations();
    initializeInteractiveElements();

    // Global frontend shell behaviors (page loader, scroll-to-top,
    // anchor scrolling, form focus) — see frontend-shell.js
    initializeFrontendShell();

    // Header family behaviors (mobile menu, topbar clock) — see header.js
    initializeHeader();
});

/**
 * Initialize page animations using Tailwind classes
 */
function initializeAnimations() {
    // Fade in animations for elements with data-animate
    const animateElements = document.querySelectorAll('[data-animate="fade-in"]');

    // Check if IntersectionObserver is supported
    if (typeof IntersectionObserver !== 'undefined') {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.remove('opacity-0', 'translate-y-4');
                    entry.target.classList.add('opacity-100', 'translate-y-0');
                }
            });
        }, {
            threshold: 0.1
        });

        animateElements.forEach(el => {
            el.classList.add('opacity-0', 'translate-y-4', 'transition-all', 'duration-700');
            observer.observe(el);
        });
    } else {
        // Fallback for browsers without IntersectionObserver
        animateElements.forEach(el => {
            el.classList.add('opacity-100', 'translate-y-0', 'transition-all', 'duration-700');
        });
    }
}

/**
 * Initialize interactive elements
 */
function initializeInteractiveElements() {
    // Enhanced button interactions
    const buttons = document.querySelectorAll('button, .btn');
    buttons.forEach(button => {
        button.addEventListener('mouseenter', function() {
            this.classList.add('transform', 'scale-105');
        });

        button.addEventListener('mouseleave', function() {
            this.classList.remove('transform', 'scale-105');
        });
    });

    // Card hover effects
    const cards = document.querySelectorAll('.card, [data-card]');
    cards.forEach(card => {
        card.addEventListener('mouseenter', function() {
            this.classList.add('shadow-lg', 'transform', 'scale-105');
        });

        card.addEventListener('mouseleave', function() {
            this.classList.remove('shadow-lg', 'transform', 'scale-105');
        });
    });
}

// Export functions for global use
window.siteHelpers = {
    initializeAnimations,
    initializeInteractiveElements
};
